<template>
  <div class="column is-3">
    <div class="box-avatar">
      <div class="avatar">
        <img
          v-if="photo"
          :src="photo"
          @click="previewImage()"
        >
        <img
          v-if="!photo"
          src="/images/profile.png"
          @click="previewImage()"
        >
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['photo'],
    data () {
      return {}
    },
    methods: {
      previewImage () {
        this.$emit('previewImage')
      }
    }
  }
</script>